import { Skeleton } from '@mui/material'

import { Tooltip } from '@/components/primitives/Tooltip'
import { Text } from '@/local/components'

import { useLastPosition } from '../hooks/useLastPosition'
import { useTexts } from '../../../useTexts'

interface Props {
  vehicle: uui.domain.client.UnifiedVehicle
}

export function LastPosition(props: Props) {
  const { vehicle } = props

  const lastPosition = useLastPosition(vehicle)
  const texts = useTexts()

  if (lastPosition === 'loading') return <Skeleton width={200} height={29} animation="wave" />

  const text = lastPosition?.address ?? texts.unknownPosition

  return (
    <div style={{ overflow: 'hidden', maxWidth: '100%' }}>
      <Tooltip title={text} placement="top">
        <Text
          data-trackid="navigo-vehicle-overview-details-single-lastPosition"
          data-testid="navigo-vehicle-overview-details-single-lastPosition"
          size="$h6"
          italic
          ellipsis
        >
          {text}
        </Text>
      </Tooltip>
    </div>
  )
}
